module.exports = __webpack_public_path__ + "static/img/thunderbay1.c0d4fb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/thunderbay1.jpg
// module id = 138
// module chunks = 9